import React from "react";
import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import colors from "../themes/colors";

export interface BreadcrumbItem {
  title?: string | null;
  link?: string;
}

export interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <MuiBreadcrumbs
      separator={<NavigateNextIcon height={20} />}
      sx={{
        color: colors.secondary.gray20,
        ".MuiBreadcrumbs-separator": {
          margin: "0 6px 0 6px"
        }
      }}>
      {items?.map((item, i) => (
        !!item.link ? (
          <Link key={i} underline="none" fontSize={18} color={colors.secondary.gray20} href={item.link}>
            {item.title}
          </Link>
        ) : (
          <Typography key={i} fontSize={18} color={colors.secondary.gray40}>
            {item.title}
          </Typography>
        )
      ))}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;